const OnlineTaskStatus = require('./OnlineTaskStatus');
const OnlineTaskTrigger = require('./OnlineTaskTrigger');

class OnlineTask {
    constructor() {
        /**
         * An incrementing number set when inserting to the database.
         * This is only populated if the task goes into the queue table. If the task runs instantly it will remain null.
         *
         * @type {Number}
         */
        this.ID = null;

        /**
         * A human-readable description of this task.
         *
         * @type {string}
         */
        this.description = '';

        /**
         * @type {string}
         */
        this.status = OnlineTaskStatus.PENDING;

        /**
         * Set when the status of a task is set to OnlineTaskStatus.RUNNING
         *
         * @type {Date}
         */
        this.lastRunAt = null;

        /**
         * @type {Date}
         */
        this.createdAt = null;

        /**
         * @type {string}
         */
        this.type = '';

        /**
         * @type {number}
         */
        this.attempts = 0;

        /**
         * Because API keys are per user the API key may change before this task gets to run.
         * The API key in use at the time the task was queued is stored here and is used as a backup by some handlers
         * if the API key at the time the task runs fails.
         *
         * @type {string}
         */
        this.apiKey = '';

        /**
         * If a task is "skippable" it will be tried once (when online) and if it fails the task will just be
         * deleted instead of marked as failed. This is for tasks that are "nice to have" rather than important.
         *
         * @type {boolean}
         */
        this.skippable = false;

        /**
         * @type {Object}
         */
        this.data = {};

        /**
         * If the task has run this will be the returned result. If it has not run this will be null.
         *
         * @type {*}
         */
        this.result = null;

        /**
         * @type {number}
         */
        this.failures = 0;

        /**
         * @type {string[]}
         */
        this.errors = [];

        /**
         * Was the task created when the device was online, offline, or online but as the result of an error?
         *
         * @type {string}
         */
        this.onlineTaskTrigger = OnlineTaskTrigger.ONLINE;
    }

    /**
     * @returns {boolean}
     */
    hasRun() {
        return this.attempts > 0;
    }
}

module.exports = OnlineTask;
